import { styled } from '@mui/material';

import { IArrestToolRow } from '@/api/api.arrests';
import { AppModal } from '@/components/Modals/AppModal';

import { ArrestsToolArrestScreen } from './ArrestsToolArrestScreen';

const StyledModal = styled(AppModal)(({ theme }) => ({
  '& .modal-content': {
    width: 1792,
    maxWidth: '95vw',
    height: '90vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    [theme.breakpoints.up('lg')]: {
      maxWidth: '95vw',
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 1792,
    },
  },
}));

export interface ArrestNavigation {
  canPrev: boolean;
  canNext: boolean;
  onPrev: () => void;
  onNext: () => void;
}

interface Props {
  open: boolean;
  row: IArrestToolRow | null;
  initialEditMode: boolean;
  onClose: () => void;
  navigation?: ArrestNavigation;
}

export const ArrestsToolArrestModal = ({
  open,
  row,
  initialEditMode,
  onClose,
  navigation,
}: Props) => (
  <StyledModal open={open} onClose={onClose} hideCloseButton>
    <div className="flex flex-col h-full overflow-hidden px-5 py-3">
      {row ? (
        <ArrestsToolArrestScreen
          key={row._id}
          row={row}
          initialEditMode={initialEditMode}
          onBack={onClose}
          navigation={navigation}
          inModal
        />
      ) : null}
    </div>
  </StyledModal>
);

export default ArrestsToolArrestModal;
